/* ==========================================================================
   Custom product page behaviour

   1. Size is required before adding to bag. No size is preselected. The buy
      button reads "Select a size" until a size is chosen, then switches to
      its normal Add to Cart label. Pressing it with no size chosen scrolls
      to the size row and shows an inline message.
   2. Sticky buy bar (Todd Snyder style). Product photo, name and price on
      the left, one button on the right that reads "Select a size" until a
      size is picked, then "Add to bag".
      - Desktop: slides down from the top once the real Add to Cart button
        has scrolled up past the header, and tucks in right under the
        header when the header is showing.
      - Mobile: sits along the bottom of the screen whenever the real Add
        to Cart button is off screen (above or below).
      "Select a size" scrolls back up to the size row; "Add to bag" adds
      the item using the real form.
   3. Stacked scroll (pinning) - currently switched off in the CSS.

   Loaded after theme.js from layout/theme.liquid.
   ========================================================================== */

(function () {
  if (!window.jQuery) { return; }
  var $ = window.jQuery;

  var SIZE_OPTION_NAMES = ['size', 'taille', 'größe', 'grösse', 'talla', 'taglia', 'maat', 'tamanho', 'størrelse'];
  var SUBMIT_SELECTOR = '.product-purchase-form [type=submit]';
  var MESSAGE_TEXT = 'Please select a size';
  var SELECT_LABEL = 'Select a size';
  var FALLBACK_LABEL = 'Add to bag';
  var BAR_ADD_LABEL = 'Add to bag';
  var SCROLL_OFFSET = 140;
  var BAR_HEIGHT = 58;
  var DESKTOP_MIN = 768;
  var NOTIFY_LABEL = 'Notify me';
  var BIS_SELECTOR = '#klaviyo-bis-button-container button';

  /* ---------------------------------------------------------- helpers --- */

  function isSizeWrapper(el) {
    var name = ($(el).attr('data-option-name') || '').toString().toLowerCase();
    return SIZE_OPTION_NAMES.indexOf(name) !== -1;
  }

  function getSizeWrapper($area) {
    return $area
      .find('.product-detail__form__options .selector-wrapper:not(.cc-swatches)')
      .filter(function () {
        return isSizeWrapper(this) && $(this).find('.clickyboxes').length > 0;
      })
      .first();
  }

  function needsSize($area) {
    return $area.data('needs-size') === true;
  }

  // The Add to Cart label the button should show once a size is chosen. Captured
  // from the server-rendered button before we swap in "Select a size".
  function defaultBuyLabel($area) {
    return $area.data('buy-label-default') || FALLBACK_LABEL;
  }

  function setBuyLabel($area, text) {
    var $btn = $area.find(SUBMIT_SELECTOR).first();
    if ($btn.length) { $btn.text(text); }
  }

  // Smooth scrolling is ignored in some embedded/preview contexts, so verify
  // the page actually moved and jump instead if it did not.
  function scrollToElement(el) {
    if (!el) { return; }

    var target = Math.max(el.getBoundingClientRect().top + window.pageYOffset - SCROLL_OFFSET, 0);
    var start = window.pageYOffset;
    if (Math.abs(target - start) < 4) { return; }

    try {
      window.scrollTo({ top: target, behavior: 'smooth' });
    } catch (e) {
      window.scrollTo(0, target);
      return;
    }

    window.setTimeout(function () {
      if (Math.abs(window.pageYOffset - start) < 4) {
        window.scrollTo(0, target);
      }
    }, 260);
  }

  function ensureMessage($area) {
    var $msg = $area.find('.size-required-msg').first();
    if ($msg.length) { return $msg; }

    var $wrapper = getSizeWrapper($area);
    if (!$wrapper.length) { return $(); }

    $msg = $('<p class="size-required-msg" role="alert"></p>').text(MESSAGE_TEXT);
    $wrapper.after($msg);
    return $msg;
  }

  function promptForSize($area) {
    var $wrapper = getSizeWrapper($area);
    if (!$wrapper.length) { return; }

    $wrapper.addClass('size-required-highlight');
    window.setTimeout(function () {
      $wrapper.removeClass('size-required-highlight');
    }, 900);

    scrollToElement($wrapper.get(0));
  }

  function clearPrompt($area) {
    $area.data('needs-size', false);
    $area.find('.size-required-msg').removeClass('is-visible');
    // A size is now chosen: restore the real Add to Cart label. If theme.js
    // sets a more specific state (e.g. Sold out) on variant change, its
    // handler runs after this and wins.
    setBuyLabel($area, defaultBuyLabel($area));
    var $bar = $('.fiori-sticky-buy');
    if ($bar.length) {
      syncStickyBar($area, $bar);
      // theme.js updates the button (e.g. Sold out) just after; re-read it.
      window.setTimeout(function () { syncStickyBar($area, $bar); }, 120);
    }
  }

  /* ------------------------------------------------------- sticky bar --- */

  function buyLabel($area) {
    if (needsSize($area)) { return SELECT_LABEL; }
    var $btn = $area.find(SUBMIT_SELECTOR).first();
    var text = $btn.length ? $.trim($btn.text()) : '';
    if (!text || /select a size/i.test(text)) { text = defaultBuyLabel($area); }
    // Brand wording on the bar: "Add to bag" (sold out etc. pass through as-is)
    if (/^add to (cart|bag)$/i.test(text)) { text = BAR_ADD_LABEL; }
    return text;
  }

  function productTitle($area) {
    var t = $area.find('.product-area__details__title, h1').first().clone();
    t.find('.fwl').remove();
    return $.trim(t.text());
  }

  function productImage() {
    var og = document.querySelector('meta[property="og:image"], meta[property="og:image:secure_url"]');
    var src = og ? og.getAttribute('content') : '';
    if (!src) {
      var img = document.querySelector('.product-area__media img');
      src = img ? (img.currentSrc || img.src) : '';
    }
    if (src && src.indexOf('//') === 0) { src = 'https:' + src; }
    if (src && src.indexOf('cdn.shopify.com') > -1) {
      src = src.replace(/([?&])width=\d+/, '$1').replace(/[?&]$/, '');
      src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=200';
    }
    return src;
  }

    function isShown(el) { return !!el && el.getClientRects().length > 0 && el.getBoundingClientRect().height > 0; }

    // Klaviyo's back-in-stock button. On a sold-out variant it hides the real
    // Add to Cart button and shows this one in its place.
    function notifyButton($area) { var el = $area.find(BIS_SELECTOR).get(0); return isShown(el) ? el : null; }

    // The button the sticky bar follows: the real Add to Cart button, or the
    // Klaviyo Notify Me button when it has replaced it.
    function trackedButton($area) { var real = $area.find(SUBMIT_SELECTOR).get(0); return isShown(real) ? real : notifyButton($area); }

  function syncStickyBar($area, $bar) {
    var price = $.trim($area.find('.current-price').first().text());
    $bar.find('.fiori-sticky-buy__price').text(price);
    var real = $area.find(SUBMIT_SELECTOR).get(0);
    var notify = !isShown(real) && !!notifyButton($area);
    var label = notify ? NOTIFY_LABEL : buyLabel($area);
    var $btn = $bar.find('.fiori-sticky-buy__btn');
    $btn.text(label);
    var soldOut = !notify && !needsSize($area) && real && real.disabled;
    $bar.toggleClass('is-notify', notify);
    $btn.toggleClass('is-disabled', !!soldOut);
    $btn.attr('aria-disabled', soldOut ? 'true' : 'false');
  }

  // Bottom edge of the visible site header on screen (0 when it is hidden /
  // scrolled away). Checks both the header group and the header bar itself
  // and takes whichever reaches lower, so no strip of page shows between
  // the header and the buy bar.
  function headerBottom() {
    var els = [
      document.querySelector('.shopify-section-group-header-group'),
      document.getElementById('site-control'),
      document.querySelector('#site-control .site-control__inner')
    ];
    var bottom = 0;
    els.forEach(function (el) {
      if (!el) { return; }
      var r = el.getBoundingClientRect();
      if (r.height > 0 && r.bottom > bottom) { bottom = r.bottom; }
    });
    // tuck 1px under the header so the two edges always meet
    return Math.max(0, Math.floor(bottom) - 1);
  }

  function buildStickyBar($area) {
    if (document.querySelector('.fiori-sticky-buy')) { return; }
    if (!$area.find('form.product-purchase-form').length) { return; }

    var img = productImage();
    var $bar = $(
      '<div class="fiori-sticky-buy" aria-hidden="true">' +
        '<div class="fiori-sticky-buy__product">' +
          (img ? '<span class="fiori-sticky-buy__thumb"><img alt="" loading="lazy"></span>' : '') +
          '<span class="fiori-sticky-buy__info">' +
            '<span class="fiori-sticky-buy__title"></span>' +
            '<span class="fiori-sticky-buy__price"></span>' +
          '</span>' +
        '</div>' +
        '<button type="button" class="fiori-sticky-buy__btn" tabindex="-1"></button>' +
      '</div>'
    );
    if (img) { $bar.find('.fiori-sticky-buy__thumb img').attr('src', img); }
    $bar.find('.fiori-sticky-buy__title').text(productTitle($area));

    $('body').append($bar);
    syncStickyBar($area, $bar);
    $bar.addClass('is-ready');

    $bar.on('click', '.fiori-sticky-buy__btn', function (e) {
      e.preventDefault();
      if ($bar.hasClass('is-notify')) {
        var notifyBtn = notifyButton($area);
        if (notifyBtn) { notifyBtn.click(); }
        return;
      }
      if ($(this).hasClass('is-disabled')) { return; }
      if (needsSize($area)) {
        promptForSize($area);
        return;
      }
      var btn = $area.find(SUBMIT_SELECTOR).get(0);
      if (btn) { btn.click(); }
    });

    $area.on('variantChanged.fioriSticky', function () {
      window.setTimeout(function () { syncStickyBar($area, $bar); }, 0);
    });

    function refresh() {
      var btn = trackedButton($area);
      // Klaviyo can swap the buttons after load or on a size change.
      if ((!!btn && btn === notifyButton($area)) !== $bar.hasClass('is-notify')) {
        syncStickyBar($area, $bar);
      }
      if (!btn) {
        $bar.removeClass('is-visible');
        return;
      }
      var r = btn.getBoundingClientRect();
      var top = headerBottom();
      var show;
      if (window.innerWidth >= 0 /* sticky bar at top on all screen sizes */) {
        // Desktop: appears once the real button has scrolled up past the header.
        $bar.css('top', top + 'px');
        show = r.bottom < top + 4;
      } else {
        // Mobile: along the bottom whenever the real button is off screen.
        $bar.css('top', '');
        show = r.top > (window.innerHeight - BAR_HEIGHT) || r.bottom < top + 4;
      }
      $bar.toggleClass('is-visible', show);
      $bar.attr('aria-hidden', show ? 'false' : 'true');
      $bar.find('.fiori-sticky-buy__btn').attr('tabindex', show ? '0' : '-1');
    }

    // Called directly rather than through requestAnimationFrame, which is
    // throttled in background tabs and would leave the bar stuck.
    window.addEventListener('scroll', refresh, { passive: true });
    window.addEventListener('resize', refresh);
    window.addEventListener('load', refresh);
    window.setTimeout(refresh, 300);
    // the header slides in/out over ~350ms; follow it
    window.setInterval(function () { if ($bar.hasClass('is-visible')) { refresh(); } }, 250);
    refresh();
  }

  /* --------------------------------------------------- stacked scroll --- */

  function initStackedScroll() {
    if (!document.querySelector('.product-area')) { return; }

    var main = document.getElementById('page-content');
    if (!main) { return; }

    var sections = Array.prototype.filter.call(main.children, function (el) {
      return el.classList && el.classList.contains('shopify-section') && el.offsetHeight > 0;
    });
    if (sections.length < 2) { return; }

    var lastLayoutWidth = window.innerWidth;

    function layout() {
      // Desktop only. (The pinning itself is switched off in
      // custom-variant-picker.css - see "Stacked scroll - TURNED OFF".)
      var stack = window.innerWidth >= 992;
      var vh = window.innerHeight;

      sections.forEach(function (sec, i) {
        sec.classList.remove('fiori-stack', 'fiori-stack-over');
        sec.style.top = '';
        sec.style.zIndex = '';

        if (!stack) { return; }

        if (i === 0) {
          var h = sec.offsetHeight;
          sec.classList.add('fiori-stack');
          sec.style.zIndex = '1';
          sec.style.top = (h > vh ? Math.round(vh - h) : 0) + 'px';
        } else {
          sec.classList.add('fiori-stack-over');
          sec.style.zIndex = '2';
        }
      });
    }

    function onResize() {
      if (window.innerWidth === lastLayoutWidth) { return; }
      lastLayoutWidth = window.innerWidth;
      layout();
    }

    layout();
    window.addEventListener('resize', onResize);
    window.addEventListener('load', layout);
    window.setTimeout(layout, 700);
    window.setTimeout(layout, 2000);
  }

  /* -------------------------------------------------------------- init --- */

  function setup($area) {
    if (!$area.length || $area.data('pdp-init') === true) { return; }
    $area.data('pdp-init', true);

    var $wrapper = getSizeWrapper($area);

    // Remember the real Add to Cart label the server rendered, so we can put
    // it back once a size is chosen.
    var $submit = $area.find(SUBMIT_SELECTOR).first();
    if ($submit.length) {
      var rendered = $.trim($submit.text());
      if (rendered && !/select a size/i.test(rendered)) {
        $area.data('buy-label-default', rendered);
      }
    }

    if ($wrapper.length && !new URLSearchParams(window.location.search).has('variant')) {
      $wrapper.find('.clickyboxes a').removeClass('active');
      $area.data('needs-size', true);
      setBuyLabel($area, SELECT_LABEL);
      // theme.js may write the button label late during its own variant init;
      // re-assert "Select a size" once while no size has been chosen yet.
      window.setTimeout(function () {
        if (needsSize($area)) { setBuyLabel($area, SELECT_LABEL); }
      }, 300);
    }

    buildStickyBar($area);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('product-purchase-form')) { return; }
    var area = form.closest ? form.closest('.product-area') : null;
    if (!area) { return; }

    if (needsSize($(area))) {
      e.preventDefault();
      e.stopImmediatePropagation();
      promptForSize($(area));
    }
  }, true);

  document.addEventListener('click', function (e) {
    if (!e.target.closest) { return; }

    var sizeLink = e.target.closest('.selector-wrapper:not(.cc-swatches) .clickyboxes a');
    if (sizeLink && isSizeWrapper(sizeLink.closest('.selector-wrapper'))) {
      var $sizeArea = $(sizeLink).closest('.product-area');
      if ($sizeArea.length) { clearPrompt($sizeArea); }
      return;
    }

    var submit = e.target.closest(SUBMIT_SELECTOR);
    if (submit) {
      var area = submit.closest('.product-area');
      if (area && needsSize($(area))) {
        e.preventDefault();
        e.stopImmediatePropagation();
        promptForSize($(area));
      }
    }
  }, true);

  function init(root) {
    $(root || document).find('.product-area').addBack('.product-area').each(function () {
      setup($(this));
    });
  }

  $(function () {
    init();
    initStackedScroll();
  });

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
